import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import NoticeDetailsContent from 'src/components/NoticesContent/OpportunitiesSearch/OpportunitiesSearchContent'

const OpportunitiesSearchPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <>
      <Navbar />
      <NoticeDetailsContent />
      <Footer />
    </>
  )
}

export default OpportunitiesSearchPage
